module.exports = __webpack_public_path__ + "img/2.4_Students-Trainees_4_Weatherall.524853d5cd74afb13c64e79cd088480f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.4_Students-Trainees_4_Weatherall.png
// module id = 769
// module chunks = 0